_ = require('underscore')

module.exports = class Country

  constructor: (options = {}) ->
    @util         = options.util
    @geometries   = options.geometries
    @iso_3166_2   = options.iso_3166_2
    @name         = options.name
    @active       = options.active == true
    @hovered      = false
    @polygons     = []

    @_buildCountryPolygons()

  render: ->
    _.each @polygons, (polygon) -> polygon.render()

  isLatLngInside: (latLng) ->
    _.some @polygons, (polygon) -> polygon.isLatLngInside(latLng)

  isHovered: ->
    @hovered == true

  onMouseHoveredLatLng: (latLng) ->
    @hovered = _.some @polygons, (polygon) -> polygon.isLatLngInside(latLng)
    @render()

  _buildCountryPolygons: ->
    _.each @geometries, (geometry) =>
      coords = _.map geometry['coordinates'][0], (coord) => { lng: coord[0], lat: coord[1] }

      @polygons.push new (require('./country_polygon'))({
        util:         @util
        country:      @
        active:       @active
        coordinates:  coords
      })


// WEBPACK FOOTER //
// ./assets/js/frontend/components/countries_map/components/map/country.coffee